import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import queryString from "query-string";

import "./CanteenReportList.css";

import history from "../../../../history";
import { getCanteenReports, settleCantteenReport, cancelCantteenReport } from "../../../../actions/canteenReportActions";

import Modal from "../../../CustomViews/Modal";

class CanteenReportList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            modal: false,
            modalType: "",
            modalAction: null,
            all: false
        };
    }

    componentDidMount() {
        let queryParams = queryString.parse(history.location.search);
        if (!(Object.keys(queryParams).length === 0 || (Object.keys(queryParams).length === 1 && queryParams.page !== null && queryParams.page !== undefined))) history.push({ search: `page=${queryParams.page}` });

        this.startPage = 0;
        this.startAll = false;
        this.updateList();
    }

    componentDidUpdate() {
        this.updateList();
    }

    updateList = () => {
        this.queryParams = queryString.parse(history.location.search);
        this.page = this.queryParams.page > 0 ? (this.queryParams.page <= this.props.pages ? +this.queryParams.page : this.props.pages) : 1
        if (this.page !== this.startPage || this.state.all !== this.startAll) {
            this.startPage = this.page;
            this.startAll = this.state.all
            this.props.getCanteenReports(this.page, this.state.all);
        }
    };

    linkTo = reportID => history.push(`/meal-orders/reports/details/${reportID}`);

    onOperationClick = (type, reportID) => this.setState({
        modal: true,
        modalType: type,
        modalAction: reportID
    });

    renderModal = () => {
        if (this.state.modal) {
            if (this.state.modalType === "settle") {
                return (
                    <Modal
                        title="Rozliczenie zestawienia"
                        content={<p>
                            Czy na pewno chcesz rozliczyć to zestawienie?<br />
                            Zamówienia podpięte pod to zestawienie zostaną oznaczone jako rozliczone.
                        </p>}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.props.settleCantteenReport(this.state.modalAction)} className="ui positive button">Rozlicz</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );
    
            } else if (this.state.modalType === "cancel") {
                return (
                    <Modal
                        title="Usunięcie zestawienia"
                        content={<p>
                            Czy na pewno chcesz usunąć to zestawienie?<br />
                            Zamówienia podpięte pod to zestawienie zostaną ponownie oznaczone jako nierozliczone.
                        </p>}
                        actions={(
                            <React.Fragment>
                                <button onClick={() => history.go(0)} className="ui button">Anuluj</button>
                                <button onClick={() => this.props.cancelCantteenReport(this.state.modalAction)} className="ui negative button">Usuń</button>
                            </React.Fragment>
                        )}
                        onDismiss={() => history.go(0)}
                    />
                );
            }
        }
    };

    renderCanteenReports = () => {
        let currentCategory = "none";
        return this.props.canteenReportList.map(canteenReport => {
            const categoryLabel = currentCategory === "none" || (currentCategory === "open" && (canteenReport.canceled === 1 || canteenReport.settled === 1));
            currentCategory = canteenReport.canceled === 0 && canteenReport.settled === 0 ? "open" : "closed";
            return (
                <React.Fragment key={canteenReport.reportID}>
                    {categoryLabel ? (
                        <div className="ui large header">
                            <div className="content">{currentCategory === "open" ? "Otwarte zestawienia:" : "Zamknięte zestawienia:"}</div>
                        </div>
                    ) : null}
                    <div className="ui segment">
                        <div className="ui grid">
                            <div className="row">
                                <div className="ten wide column">
                                    <div className="ui big header">
                                        Zestawienie nr: {canteenReport.reportID}<br />
                                        za okres od: {canteenReport.dateFrom} do: {canteenReport.dateTo}
                                    </div>
                                </div>
                                <div className="six wide right aligned column">
                                    {canteenReport.canceled === 0 ? (
                                        <React.Fragment>
                                            {canteenReport.settled === 0 ? (
                                                <button className="ui positive button" type="button" onClick={() => this.onOperationClick("settle", canteenReport.reportID)}>Rozlicz</button>
                                            ) : null}
                                            <button className="ui negative button" type="button" onClick={() => this.onOperationClick("cancel", canteenReport.reportID)}>Usuń</button>
                                            <button className="ui primary button" type="button" onClick={() => this.linkTo(canteenReport.reportID)}>Wyświetl</button>
                                        </React.Fragment>
                                    ) : null}
                                </div>
                            </div>
                            <div className="ui divider" />
                            <div className="two columns row">
                                <div className="column">
                                    <div className="content">Wygenerowane dnia: <b>{canteenReport.generatedOn}</b></div>
                                </div>
                                <div className="right aligned column">
                                    <div className={`${canteenReport.canceled === 1 ? "red" : (canteenReport.settled === 1 ? "green" : "orange")} content`}>
                                        <b>{canteenReport.canceled === 1 ? "Usunięte" : (canteenReport.settled === 1 ? "Rozliczone" : "Nierozliczone")}</b>
                                    </div>
                                </div>
                            </div>
                        </div>  
                    </div>
                </React.Fragment>
            );
        });
    };

    renderPagination = () => {
        let buttons = [];
        let ellipsis = true;

        buttons.push(this.renderPaginationButton(-2));
        for (let i = 1; i <= this.props.pages; i++) {
            if ((i < this.page && i - 1 > 0 && this.page - i > (this.page === this.props.pages ? 2 : 1) && this.page - 1 > (this.page === this.props.pages ? 4 : 3)) || (i > this.page && this.props.pages - i > 0 && i - this.page > (this.page === 1 ? 2 : 1) && this.props.pages - this.page > (this.page === 1 ? 4 : 3))) {
                if (ellipsis) {
                    buttons.push(this.renderPaginationButton(i, true));
                    ellipsis = false;
                }
                continue;
            }
            if (i === this.page) ellipsis = true;
            buttons.push(this.renderPaginationButton(i));
        }
        buttons.push(this.renderPaginationButton(-1));

        return (
            <div className="ui pagination menu">
                {buttons}
            </div>
        );
    }

    renderPaginationButton = (page, ellipsis = false) => {
        let destination = page > 0 ? page : (page === -2 ? +this.page - 1 : +this.page + 1);
        return (
            <React.Fragment key={page}>
                {(destination < 1 || destination > this.props.pages || ellipsis) ? (
                    <div className="disabled item">{ellipsis ? "..." : (page > 0 ? page : (page === -2 ? "<" : ">"))}</div>
                ) : (
                    <Link to={`${history.location.pathname}?${queryString.stringify({ page: destination, ...this.filtersParams })}`} className={`${(destination < 1 || destination > this.props.pages) ? "disabled " : ""}item${page === this.page ? " active" : ""}`}>
                        <div className="content">{page > 0 ? page : (page === -2 ? "<" : ">")}</div>
                    </Link>
                )}
            </React.Fragment>
        );
    }

    render() {
        return (
            <React.Fragment>
                <div className="canteen-report-list-component ui container">
                    <div className={`ui ${this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? "four" : "two"} item menu`}>
                        <Link to="/meal-reservations/my" className="item">
                            <div className="content">Rezerwacje</div>
                        </Link>
                        <Link to="/meal-orders/my" className="item">
                            <div className="content">Moje zamówienia</div>
                        </Link>
                        {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                            <React.Fragment>
                                <Link to="/meal-orders/today" className="item">
                                    <div className="content">Korekty zamówień</div>
                                </Link>
                                <Link to="/meal-orders/reports" className="active item">
                                    <div className="content">Zestawienia</div>
                                </Link>
                            </React.Fragment>
                        ) : null}
                    </div>
                    {this.props.currentUser.ouID === +process.env.REACT_APP_HR_OU_ID ? (
                        <div className="ui three item menu">
                            <Link to="/meal-orders/unsettled" className="item">
                                <div className="content">Nierozliczone zamówienia</div>
                            </Link>
                            <Link to="/meal-orders/reports" className="active item">
                                <div className="content">Wygenerowane zestawienia</div>
                            </Link>
                            <Link to="/meal-orders/reports/new" className="item">
                                <div className="content">Nowe zestawienie</div>
                            </Link>
                        </div>
                    ) : null}
                    <div className="ui toggle container">
                        <button className="ui primary filters button" type="button" onClick={event => {
                            event.target.blur();
                            this.setState({ all: !this.state.all });
                        }}>{this.state.all ? "Ukryj usunięte" : "Pokaż usunięte"}</button>
                    </div>
                    <div className="ui divider" />
                    <div className="ui container">
                        {this.props.canteenReportList.length ? (
                            <React.Fragment>
                                {this.renderCanteenReports()}
                                <div className="ui divider" />
                                {this.renderPagination()}
                            </React.Fragment>
                        ) : (
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="table icon"></i>
                                        <div className="content">Nie odnaleziono zestawień</div>
                                    </h2>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {this.renderModal()}
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    currentUser: state.user.current,
    canteenReportList: state.canteenReport.list,
    pages: state.canteenReport.pages
});

export default connect(mapStateToProps, { getCanteenReports, settleCantteenReport, cancelCantteenReport })(CanteenReportList);